var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loading",style:(_vm.cssStyle)},[_c('loader',{attrs:{"color":"#c9c9c9","size":"5px"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }